import { StickyPosition } from '@repo/types';

export const AdsProvider = {
  SnackMedia: 'SnackMedia',
  Custom: 'Custom',
} as const;
export type AdsProvider = (typeof AdsProvider)[keyof typeof AdsProvider];

export const AdSize = {
  /**
   * Header ad
   * Desktop: 728x90, 970x90
   * Mobile: 300x250, 320x50, 320x100
   */
  snack_ldb: 'snack_ldb',
  /**
   * Main sidebar ad
   * Desktop: 300x600, 300x250
   * Mobile: 300x250, 320x50, 320x100
   */
  snack_dmpu: 'snack_dmpu',

  /**
   * Secondary sidebar ad
   */
  snack_mpu: 'snack_mpu',

  /**
   * Sticky footer ad
   * Desktop: 728x90, 970x90, 468x60
   * Mobile: 320x50
   */
  snack_dex1: 'snack_dex1',

  /**
   * In between page content ad
   */
  snack_dex2: 'snack_dex2',

  /**
   * In between page content ad
   */
  snack_dex3: 'snack_dex3',

  /**
   * In between page content ad
   */
  snack_dex4: 'snack_dex4',

  /**
   * In between page content ad
   */
  snack_dex5: 'snack_dex5',

  /**
   * SM video player ad
   */
  video: 'video',
} as const;
export type AdSize = (typeof AdSize)[keyof typeof AdSize];

export type AdFormData = {
  provider: AdsProvider;
  script?: string;
  adSize?: AdSize;
  isSticky?: boolean;
  stickyPosition?: StickyPosition;
};
